export default __webpack_public_path__ + "static/media/branchcircuitmonitor.002314ca.webp";